import EditorialPortfolioLayout from './EditorialPortfolioLayout';
import FramedPortfolioLayout from './FramedPortfolioLayout';
import GridShowcaseLayout from './GridShowcaseLayout';
import SpotlightPortfolioLayout from './SpotlightPortfolioLayout';
import StackedPortfolioLayout from './StackedPortfolioLayout';

export const layoutRegistry = {
  'stacked-portfolio': {
    key: 'stacked-portfolio',
    label: 'Stacked Portfolio',
    component: StackedPortfolioLayout,
  },
  'spotlight-portfolio': {
    key: 'spotlight-portfolio',
    label: 'Spotlight Portfolio',
    component: SpotlightPortfolioLayout,
  },
  'framed-portfolio': {
    key: 'framed-portfolio',
    label: 'Framed Portfolio',
    component: FramedPortfolioLayout,
  },
  'editorial-portfolio': {
    key: 'editorial-portfolio',
    label: 'Editorial Portfolio',
    component: EditorialPortfolioLayout,
  },
  'grid-showcase': {
    key: 'grid-showcase',
    label: 'Grid Showcase',
    component: GridShowcaseLayout,
  },
};

export const defaultLayoutKey = 'stacked-portfolio';

export const getLayoutDefinition = (layoutKey) =>
  layoutRegistry[layoutKey] || layoutRegistry[defaultLayoutKey];
